module.exports = __webpack_public_path__ + "img/Micromonas_commoda.26658249.jpg";